import gql from 'graphql-tag'

export const insertCompany = ({ company }) => {
	return {
		mutation: gql`
			mutation ($company: companies_insert_input!) {
				insert_companies_one(object: $company) {
					id
				}
			}
		`,
		variables: { company }
	}
}
